import ViewSpeciality from "./ViewSpeciality";
import { DELETE_SPECIALTY } from "./query";
import { Delete, Tabs } from "../shared";
import SpecialityForm from "./SpecialityForm";

const SubComponent = ({ data }) => {
    const { id, groupId, specialtyId } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `view-${id}`,
                    name: "View Speciality",
                    content: <ViewSpeciality data={data} />,
                },
                {
                    id: `update-${id}`,
                    name: "Update Speciality",
                    content: (
                        <>
                            <h5 className="mb-4">Update Group Specialty</h5>
                            <SpecialityForm
                                formType="update"
                                formData={{ id, groupId, specialtyId }}
                            />
                        </>
                    ),
                },
                {
                    id: `delete-${id}`,
                    name: "Delete Speciality",
                    content: (
                        <Delete
                            title="Group Speciality"
                            id={id}
                            query={DELETE_SPECIALTY}
                            cacheName="allAbbvieProSpecialtyMaps"
                        />
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
